import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const TICKET_SALES_REPORT_V2 = gql`
  mutation TicketSalesReportV2Mutation($eventId: Int!) {
    getTicketSalesReportV2(event_id: $eventId) {
      event {
        id
        logo
        name
        month
        day
        date
        isMultiDay
        start_date
        end_date
        track {
          id
          name
        }
      }
      tickets_sold
      ticket_groups {
        label
        start_date
        end_date
        total
        tickets {
          name
          qty
          price
        }
      }
      days {
        label
        date
        total
        tickets {
          name
          qty
        }
      }
      tier_breakdown {
        name
        qty
        tiers {
          name
          qty
          price
        }
      }
    }
  }
`;

export function useGetTicketSalesReportV2() {
  const [ticketSalesReportV2Mutation] = useMutation(TICKET_SALES_REPORT_V2);
  const result = useCallback(
    (eventId) => {
      return ticketSalesReportV2Mutation({
        variables: {
          eventId: Number(eventId),
        },
      });
    },
    [ticketSalesReportV2Mutation]
  );
  return result;
}
